"use client";

import { c as _c } from "react/compiler-runtime";
import { IconHome, IconRefresh } from "@tabler/icons-react";
import Link from "next/link";
import { Button } from "@/components/ui/button";
import { ErrorPageShell } from "./ErrorPageShell";
interface Props {
  reset: () => void;
}
export function ErrorContent(t0) {
  const $ = _c(7);
  const {
    reset
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="flex h-full w-full items-center justify-center bg-white"><span className="text-8xl font-black tracking-tight text-primary">BRB!</span></div>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <IconRefresh />;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== reset) {
    t3 = <Button size="lg" onClick={reset} className="transition-transform hover:scale-[1.03]">{t2}Try again</Button>;
    $[2] = reset;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <Button asChild={true} size="lg" variant="outline" className="transition-transform hover:scale-[1.03]"><Link href="/"><IconHome />Home</Link></Button>;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== t3) {
    t5 = <ErrorPageShell watermark="500" sticker={t1} heading="Something Came Unstuck." description="We hit an unexpected error. Try again, or head back home." cta={<div className="flex flex-wrap items-center justify-center gap-3">{t3}{t4}</div>} />;
    $[5] = t3;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  return t5;
}